/**
 * the formattedPhoneNumber will iterate over the characters supplied and add appropriate chars.
 * If the extension arg is supplied, it will be appended the the end of the formatted phone number.
 **/
export default function formatPhoneNumber(int, ext) {
  const myPhone = int.toString();
  const numLength = myPhone.length;
  const newPhone = [];
  const char = {
    3: '-',
    6: ') ',
    9: numLength > 10 ? ' (' : '('
  };
  let i = numLength - 1;
  let count = 0;
  for (i; i >= 0; i -= 1) {
    // if the index matches the value breaks, the corresponding character will be
    // prepended to the newPhone array along with the value
    newPhone.unshift(char[count] || '', myPhone[i]);
    count += 1;
  }
  if (ext) {
    return newPhone.join('').concat(' ext', ext);
  }
  return newPhone.join('');
}